__turbopack_context__.v({
  "container": "Container-module__dOPCMW__container",
});
